import React, { useState, useEffect } from "react"
import AppBar from "@mui/material/AppBar"
import Box from "@mui/material/Box"
import Toolbar from "@mui/material/Toolbar"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import MenuIcon from "@mui/icons-material/Menu"
import Container from "@mui/material/Container"
import Button from "@mui/material/Button"
import SignUpModal from "./SignUpModal"
import LoginModal from "./LoginModal"
import UserProfileMenu from "./UserProfileMenu"
import { styled, alpha } from "@mui/material/styles"
import CreateIcon from "@mui/icons-material/Create"
import SearchBar from "./SearchBar"
import MobileDrawer from "./MobileDrawer"
const pages = ["Health", "Technology", "Finance", "Travel", "Food", "Lifestyle", "Fashion", "Entertainment", "Career"]

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 90%)`,
  boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.appBar,
  width: "100vw",
}))

const LogoWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  "&:hover": {
    "& .MuiSvgIcon-root": {
      transform: "translateX(5px)",
    },
  },
}))

const LogoText = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins, sans-serif",
  fontWeight: 700,
  letterSpacing: ".3rem",
  color: "inherit",
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  "& .highlight": {
    color: theme.palette.secondary.light,
    textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
  },
}))

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.1),
  },
  "&.active": {
    backgroundColor: alpha(theme.palette.common.white, 0.2),
    fontWeight: "bold",
  },
  transition: "all 0.3s",
}))

function NavBar({ onCategorySelect, onSearch, blogs }) {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [isSignUpOpen, setIsSignUpOpen] = useState(false)
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [userProfileImage, setUserProfileImage] = useState("")

  useEffect(() => {
    if (selectedCategory) {
     
     
      onSearch("")
    }
  }, [selectedCategory, onSearch])

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const handleCloseNavMenu = (category) => {
    setSelectedCategory(category)
    onCategorySelect(category)
    setMobileOpen(false)
    onSearch("")
  }

  const handleHome = () => {
    setSelectedCategory(null)
    onCategorySelect(null)
    setMobileOpen(false)
    onSearch("")
  }

  const handleOpenSignUp = () => {
    setIsSignUpOpen(true)
  }

  const handleCloseSignUp = () => {
    setIsSignUpOpen(false)
  }

  const handleOpenLogin = () => {
    setIsLoginOpen(true)
  }

  const handleCloseLogin = () => {
    setIsLoginOpen(false)
  }
  const handleSuccessfulLogin = () => {
    const userData = JSON.parse(localStorage.getItem("userdata"));
  
    // Check if userData and userName exist
    if (userData && userData.userName) {
      const userName = userData.userName;
      // Get the first letter of the username
      const firstLetter = userName.charAt(0).toUpperCase();
  
      // console.log("userName", userName); // Use the user data as needed
      // console.log("firstLetter", firstLetter);
  
      setIsLoggedIn(true);
      setUserProfileImage(firstLetter); // Set the first letter as profile image
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("userProfileImage", firstLetter); // Store the first letter in localStorage
      
    } else {
      console.error("User data or username not found.");
    }
  
    handleCloseLogin();
  };
  

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (loggedIn) {
      setIsLoggedIn(true);
      const storedProfileImage = localStorage.getItem("userProfileImage");
      if (storedProfileImage) {
        setUserProfileImage(storedProfileImage); // Load stored first letter profile image
      }
    }
  }, []);


  const handleLogout = () => {
    setIsLoggedIn(false)
    localStorage.removeItem("isLoggedIn")
    localStorage.removeItem("userProfileImage")
    setUserProfileImage("/placeholder.svg?height=40&width=40")
  }

  return (
    <StyledAppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <LogoWrapper onClick={handleHome}>
            <LogoText
              variant="h6"
              noWrap
              component="a"
              sx={{
                mr: 2,
                display: { xs: "none", sm: "flex" },
              }}
            >
              Blog<span className="highlight">Swipe</span>
            </LogoText>
          </LogoWrapper>

          <Box sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" } }}>
            {pages.map((page) => (
              <StyledButton
                key={page}
                onClick={() => handleCloseNavMenu(page)}
                className={page === selectedCategory ? "active" : ""}
              >
                {page}
              </StyledButton>
            ))}
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", sm: "none" } }} />

          <SearchBar onSearch={onSearch} blogs={blogs} />

          <Box sx={{ flexGrow: 0, ml: 2, display: { xs: "flex", sm: "none" }, alignItems: "center" }}>
  {isLoggedIn ? (
    <UserProfileMenu userProfileImage={userProfileImage} onLogout={handleLogout} />
  ) : (
    <IconButton
      color="inherit"
      onClick={handleOpenSignUp}
      sx={{
        display: { xs: "flex", sm: "none" },
        justifyContent: "center",
        alignItems: "center",
        p: 1,
        backgroundColor: alpha("#ffffff", 0.1),
        "&:hover": {
          backgroundColor: alpha("#ffffff", 0.2),
        },
      }}
    >
      <CreateIcon />
    </IconButton>
  )}
</Box>
<Box sx={{ flexGrow: 0, ml: 2, display: { xs: "none", sm: "flex" } }}>
  {isLoggedIn ? (
    <UserProfileMenu userProfileImage={userProfileImage} onLogout={handleLogout} />
  ) : (
    <Button color="inherit" onClick={handleOpenSignUp} startIcon={<CreateIcon />}>
      Write a blog?
    </Button>
  )}
</Box>

        </Toolbar>
      </Container>
      <MobileDrawer
        pages={pages}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        handleCloseNavMenu={handleCloseNavMenu}
        selectedCategory={selectedCategory}
      />
      <SignUpModal
        open={isSignUpOpen}
        onClose={handleCloseSignUp}
        onOpenLogin={handleOpenLogin}
        onSuccessfulLogin={handleSuccessfulLogin}
      />
      <LoginModal open={isLoginOpen} onClose={handleCloseLogin} onSuccessfulLogin={handleSuccessfulLogin} />
    </StyledAppBar>
  )
}

export default NavBar;

